import { render, staticRenderFns } from "./TestListCreateRoute.vue?vue&type=template&id=6f19ec62&scoped=true&"
import script from "./TestListCreateRoute.vue?vue&type=script&lang=js&"
export * from "./TestListCreateRoute.vue?vue&type=script&lang=js&"
import style0 from "./TestListCreateRoute.vue?vue&type=style&index=0&id=6f19ec62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f19ec62",
  null
  
)

export default component.exports